import { OnInit, } from '@angular/core';
import { fromEvent, } from 'rxjs';
import { map, startWith, } from 'rxjs/operators';
var UiPasswordTypeToggleComponent = /** @class */ (function () {
    function UiPasswordTypeToggleComponent() {
        this.tooltipShow = 'Show';
        this.tooltipHide = 'Hide';
        this.isTypePassword = true;
    }
    Object.defineProperty(UiPasswordTypeToggleComponent.prototype, "tooltip", {
        get: function () {
            return this.isTypePassword ? this.tooltipShow : this.tooltipHide;
        },
        enumerable: true,
        configurable: true
    });
    UiPasswordTypeToggleComponent.prototype.onClick = function () {
        this.isTypePassword = !this.isTypePassword;
        this.element.type = this.isTypePassword ? 'password' : 'text';
    };
    UiPasswordTypeToggleComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.enabled$ = fromEvent(this.element, 'keyup')
            .pipe(startWith({}), map(function () {
            var value = _this.element.value;
            return !!value && !/^\u2022+$/.test(value);
        }));
    };
    return UiPasswordTypeToggleComponent;
}());
export { UiPasswordTypeToggleComponent };
